<template>
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="small-12 medium-5 large-3 small-order-2 medium-order-1">
                <div class="grid-x grid-margin-x">
                    <div class="cell small-12 medium-12">
                        <div class="img h"></div>
                        <div class="post">
                            <strong>Павел Хлюстов</strong>
                            Управляющий партнёр АБ «Павел Хлюстов и Партнёры», адвокат, кандидат юридических наук
                        </div>
                    </div>
                    <div class="cell small-12 medium-12">
                        <div class="img g"></div>
                        <div class="post">
                            <strong>Алексей Гуров</strong>
                            Партнёр АБ «Павел Хлюстов и Партнёры», адвокат, кандидат юридических наук
                        </div>
                    </div>
                </div>
            </div>
            <div class="column large-2 small-order-1 medium-order-2 show-for-medium"></div>
            <div class="cell small-12 medium-7 large-6 small-order-1 medium-order-3">
                <header class="page_header">
                    <button type="button" class="back_btn show-for-small-only" @click="overlayClose">Назад</button>
                    О проекте
                </header>
                <article class="case_content">
                    <p>7 мая 2000 года президентом России стал Владимир Путин. Началась новая эпоха. С этого дня прошло 20 лет – серьезный период в истории нашей страны. На него можно смотреть с разных сторон, образующих единое целое. Одной из них является правоохранительная система.</p>
                    <p>Ее состояние позволяет определить, что происходит в обществе и как государство на это реагирует. И наоборот, что делает государство и как реагирует на это общество. Особенно ярко это проявляется в таком аспекте, как уголовное преследование. Именно здесь виднеется апогей столкновения интересов государства и личности.</p>
                    <p>Мы решили вспомнить уголовные дела, наиболее ярко характеризующие изменения, происходившие за последние 20 лет.</p> 
                    <p>Специализация Адвокатского бюро «Павел Хлюстов и Партнёры» связана с защитой предпринимателей и государственных служащих, поэтому мы решили остановиться именно на них. Проанализировав более 100 заметных уголовных дел, мы выбрали 20: 10 дел бизнесменов и 10 дел чиновников. При отборе мы учитывали статус и количество фигурантов, тяжесть вменяемого преступления, экономические последствия, а также влияние дела на умонастроения в обществе.</p>
                    <p>Стоит предостеречь читателя от политической оценки нашего проекта. Мы не только не ставили себе такую задачу, а сделали его, напротив, сугубо историографическим. Нам лишь хотелось дать возможность посмотреть на отрезок жизни нашей страны сквозь призму значимых уголовных дел бизнесменов и чиновников. </p>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "About",
    data: () => ({
        
    }),
    created(){
        this.$root.$emit('setNav', false)
    },
    methods: {
        overlayClose(){
            this.$root.$emit('hideOverlay')
        }
    }
}
</script>

<style lang="scss">
    .img { height:350px; margin-top:$space; margin-left:$space!important;
        &.h { background:url("~@/../public/img/hlyustov.jpg") no-repeat center top/cover }
        &.g { background:url("~@/../public/img/gurov.jpg") no-repeat center -50px /cover }
        
            
    }

    .post {
        font-family:$sans-serif; font-size:fsz(.9rem); margin-top:$space; color:#484848; line-height:1.1; margin-left:$space!important;
        strong { display:block; color:$black; margin-bottom:$space/3; }
    }
</style>